import { EmailDomainsService } from './service/email-domains.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditEmailDomainsComponent } from './edit-email-domains/edit-email-domains.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material/material.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { CommonComponentsModule } from '../common-components/common-components.module';
import { EmailDomainsRoutingModule } from './email-domains-routing.module';

@NgModule({
    declarations: [EditEmailDomainsComponent],
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule, PipesModule, CommonComponentsModule, EmailDomainsRoutingModule],
    providers: [EmailDomainsService]
})
export class EmailDomainsModule {}
